import axios from "axios"

const state = {
  STATUS: null,
  API_ROUTE: "/organisations",
  organizationsList: [],
  totalOrganizations: 0,
  orgChanges: null
}

const getters = {
  organizationsList: (state) => state.organizationsList,
  totalOrganizations: (state) => state.totalOrganizations
}

const mutations = {
  setOrganizations(state, organizations) {
    state.organizationsList = organizations
  },
  setTotalOrganizations(state, total) {
    state.totalOrganizations = total
  },
  setOrgChanges(state, orgChanges) {
    state.orgChanges = orgChanges
  }
}

const actions = {
  async listOrganizations({ commit }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.get(url, config)
      commit("setOrganizations", response.data)
      commit("setTotalOrganizations", response.data.length)

      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async updateUserOrganizations({ commit }, { userType, organizations, targetUserId }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/user/${userId}/${userType}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const data = {
        organisations: organizations,
        target_user_type_id: targetUserId // as we don't easily have the userID, we should pass the id based on userType, so doctor table id for doctor, etc. 
      }
      const response = await window.axios.patch(url, data, config)
      commit("setOrgChanges", response.data)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
